import { CAPABILITY } from "../../../helpers/permissions";
import {
  buildAccountsReceivableDashboard,
  loadReceivableInvoices,
} from "../../../helpers/accountsReceivable";
import { buildGuestExecutiveBriefingData } from "../executiveBriefingGuestDemo";
import { formatBriefingCurrency, pluralize } from "../formatBriefingSpeech";

export const ACCOUNTS_RECEIVABLE_PROVIDER_ID = "accountsReceivable";

async function loadReceivablesSnapshot(ctx) {
  if (ctx.isGuest) {
    return buildGuestExecutiveBriefingData().accountsReceivable;
  }

  if (ctx.isOffline || !ctx.actor) {
    return null;
  }

  const invoices = await loadReceivableInvoices(ctx.actor, ctx.supabaseClient);
  const dashboard = buildAccountsReceivableDashboard(invoices, ctx.date);

  return {
    invoiceCount: dashboard.invoiceCount,
    outstandingReceivables: dashboard.outstandingReceivables,
  };
}

export const accountsReceivableProvider = {
  id: ACCOUNTS_RECEIVABLE_PROVIDER_ID,
  isEligible(ctx) {
    return ctx.can(CAPABILITY.ACCOUNTS_RECEIVABLE_VIEW);
  },
  loadData: loadReceivablesSnapshot,
  buildSection(_ctx, data) {
    if (!data) {
      return null;
    }

    const { invoiceCount, outstandingReceivables } = data;

    if (invoiceCount <= 0) {
      return "Receivables are all caught up.";
    }

    const amountPhrase = formatBriefingCurrency(outstandingReceivables);
    const invoicePhrase = pluralize(invoiceCount, "outstanding invoice");

    if (amountPhrase) {
      return `You have ${invoicePhrase} on the books, totaling ${amountPhrase}.`;
    }

    return `You have ${invoicePhrase} on the books.`;
  },
};
